module.exports = __webpack_public_path__ + "img/27.b918ee08.png";